export default {
  'Your win': '你贏到的',
  'Select skins that you want to take': '選取你要拿的武器造型',
  'By price': '依價格',
  '(Autotrade will receive after 10 minutes)': '(自動貿易會在 10 分鐘後收到)',
  ACCEPT: '確認',
  'SELECT ALL': 'SELECT ALL',
};
